/**
 * 解析token成JSON
 */
export function parseJWT(token: string) {
  const base64Url = token.split('.')[1]; // 获取 payload 部分
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map(c => '%' + c.charCodeAt(0).toString(16).padStart(2, '0'))
      .join('')
  );
  return JSON.parse(jsonPayload);
}

/**
 * 格式化预约时间为 "August 16th 11:15-11:45" 格式
 * @param appointmentTime 原始时间字符串，格式如 "2025-08-29 16:25:41"
 * @returns 格式化后的时间字符串
 */
export function formatAppointmentTime(appointmentTime: string): string {
  if (!appointmentTime) return '';
  
  try {
    const date = new Date(appointmentTime);
    
    // 检查日期是否有效
    if (isNaN(date.getTime())) {
      return appointmentTime; // 如果解析失败，返回原始字符串
    }
    
    // 月份名称数组
    const monthNames = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
    
    // 获取月份名称
    const monthName = monthNames[date.getMonth()];
    
    // 获取日期并添加后缀
    const day = date.getDate();
    const daySuffix = getDaySuffix(day);
    
    // 获取小时和分钟
    const hours = date.getHours();
    const minutes = date.getMinutes();
    
    // 没有结束时间
    const endHours = '';
    const endMinutes = '';
    
    // 格式化时间
    const startTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
    const endTime = `${endHours.toString().padStart(2, '0')}:${endMinutes.toString().padStart(2, '0')}` || '';
    
    return `${monthName} ${day}${daySuffix} ${startTime}-${endTime}`;
  } catch (error) {
    console.error('Error formatting appointment time:', error);
    return appointmentTime; // 如果出错，返回原始字符串
  }
}

/**
 * 获取日期的后缀（st, nd, rd, th）
 * @param day 日期数字
 * @returns 后缀字符串
 */
function getDaySuffix(day: number): string {
  if (day >= 11 && day <= 13) {
    return 'th';
  }
  
  switch (day % 10) {
    case 1:
      return 'st';
    case 2:
      return 'nd';
    case 3:
      return 'rd';
    default:
      return 'th';
  }
}
